export function convertFullAddress(obj: {
  street: string;
  city: string;
  state: string;
  zip: string;
}) {
  return obj && [obj.street, obj.city, obj.state, obj.zip].join(', ');
}
